import { useState } from "react";

const FAQS = [
    {
        q: "Does C-ORE C-Suites work with my version of Tally?",
        a: "Yes — all Tally Prime (2.x, 3.x, 4.x) and Tally ERP 9 releases. Our agent auto-detects your version.",
    },
    {
        q: "How long does setup take?",
        a: "Under 60 minutes. Our team installs the agent with you on a video call and your dashboard goes live within 5 minutes.",
    },
    {
        q: "Is my financial data secure?",
        a: "Encrypted with 256-bit SSL, stored on enterprise-grade, geo-redundant servers across India, GCC and EU regions. The agent only reads data — it cannot modify Tally.",
    },
    {
        q: "What if Tally is closed or the computer is off?",
        a: "The agent queues data locally and syncs the moment Tally reopens. No data lost.",
    },
    {
        q: "Can I use it without Tally?",
        a: "Currently optimised for Tally. Zoho Books and bank statement integrations are coming. Contact us for other setups.",
    },
    {
        q: "Do you offer a free trial?",
        a: "Yes — every plan starts with a 1-month free trial. No credit card required. Our team sets up your account and connects Tally free during the trial.",
    },
    {
        q: "What support do you provide?",
        a: "Email support on all plans. WhatsApp support Monday to Saturday 9am–7pm IST. Sovereign members get priority support and a direct line to the founders.",
    },
    {
        q: "Can my CA access the dashboard?",
        a: "Yes. Add your CA as a user to view reports, download MIS PDFs, and see AI insights at no extra cost.",
    },
];

export default function Faq() {
    const [openIdx, setOpenIdx] = useState(0);

    return (
        <section className="faq" id="faq" data-testid="v2-faq">
            <div className="container">
                <div className="faq__head reveal">
                    <span className="faq__eyebrow">FAQ</span>
                    <h2 className="faq__title">Questions we hear often.</h2>
                </div>
                <div className="faq__list">
                    {FAQS.map((item, i) => {
                        const isOpen = openIdx === i;
                        return (
                            <div
                                key={i}
                                className="faq__item reveal"
                                data-state={isOpen ? "open" : "closed"}
                                data-testid={`v2-faq-item-${i}`}
                            >
                                <button
                                    type="button"
                                    className="faq__q"
                                    onClick={() => setOpenIdx(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}
                                    data-testid={`v2-faq-question-${i}`}
                                >
                                    <span>{item.q}</span>
                                    <span
                                        className="faq__caret"
                                        aria-hidden="true"
                                    >
                                        <svg
                                            width="14"
                                            height="14"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                            stroke="currentColor"
                                            strokeWidth="2.4"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                        >
                                            <polyline points="6 9 12 15 18 9" />
                                        </svg>
                                    </span>
                                </button>
                                <div className="faq__body">
                                    <div className="faq__body-inner">
                                        {item.a}
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
